import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from '../../services/auth.service';
import { MensajesService } from '../../services/mensajes.service';
import { environment } from 'src/environments/environment';
import { SeguridadService } from 'src/app/services/seguridad.service';

@Component({
  selector: 'app-login',
  templateUrl: './app.login.component.html',
})
export class AppLoginComponent {

    formGroup: FormGroup;
    passType: string = 'password';
    loading: boolean = false;
    version = environment.VERSION;
    fecha = environment.FECHA;

    constructor( 
        private route: Router,
        private fb: FormBuilder,
        private authService: AuthService,
        private message: MessageService,
        private mensajeService: MensajesService,
        private seguridadService: SeguridadService
    ) { 
        this.createForm();
    }

    async login( cerrar_sesion?: boolean  ) {
        if ( this.formGroup.invalid ) {
            await this.setInvalidControls();
            this.message.add({key: 'top-right', severity: 'error', summary: 'Formulario Inválido', detail: 'Complete los campos obligatorios'})
            return;
        }
        const value = {
            ...this.formGroup.value,
            cerrar_sesion: cerrar_sesion
        }
        this.loading = true;
        const resp = await this.authService.login(value);
        if (resp.ok) {
            if ( value.recordar ) {
                this.seguridadService.setUserRemember({
                    usuario: value.usuario,
                    recordar: true
                });
            } else {
                this.seguridadService.setUserRemember();
            }
            this.route.navigate(['pages','home', 'inicio'])
        } else {
            if ( resp?.resp?.sesion_abierta ) {
                await this.question();
            } else {
                this.showLoginError(resp.msg, resp.resp);
            }
        }
        this.loading = false;
    }

    async createForm() {
        this.seguridadService.clearLegacyPasswordState();
        const userRemember = await this.seguridadService.getUserRemember();
        this.formGroup = this.fb.group({
            usuario: [userRemember?.usuario ? userRemember.usuario : null, Validators.required],
            password: [null, Validators.required],
            recordar: [ userRemember?.recordar ? true : false ]
        });
    }

    async setInvalidControls() {
        Object.keys(this.formGroup.controls).forEach( key => {
            this.formGroup.controls[key].markAsDirty();
        });
    }

    invalidControl( name: string ) {
        return this.formGroup.get(name).invalid && this.formGroup.get(name).touched;
    }

    async question() {
        const resp = await this.mensajeService.preguntar('Sesión Abierta', 'Actualmente tiene una sesión abierta. Desea cerrar la sesión?');
        if ( resp ) {
            this.login(true);
        }
    }

    /**
     * Muestra un mensaje de error correspondiente al formulario de login.
     * @param summary titulo del mensaje de error.
     * @param detail descripción del mensaje de error.
     */
    showLoginError(summary: string, detail: string): void {
        this.message.add({key: 'top-right', severity: 'error', summary, life: 7000, detail });
    }

    showPassword( passType: string ) {
        this.passType = passType;
    }
}
